import { Directive, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appTextIsTruncated]',
  standalone: false
})
export class TextIsTruncatedDirective implements AfterViewInit {
  @Output() isTruncated = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    // Add a slight delay to ensure DOM is fully rendered
    setTimeout(() => {
      const element = this.el.nativeElement;
      const isTruncated = element.scrollWidth > element.clientWidth;
      console.log('TextIsTruncatedDirective: isTruncated =' + isTruncated + ' for element:', element);
      this.isTruncated.emit(isTruncated);
    }, 0);
  }
}